import React from 'react';
import {useSelector} from 'react-redux';
import {t} from '@lingui/core/macro';

import {IMessengerChat, telegramChatAPI} from 'entities/notification';
import {userSelector} from 'entities/user';

import NotifyChannelSection from '../NotifyChannel/NotifyChannelSection';
import NotifyChannelRow from '../NotifyChannel/NotifyChannelRow';
import NotifyChannelEditModal from '../NotifyChannel/NotifyChannelEditModal';
import NotifyChannelDeleteModal from '../NotifyChannel/NotifyChannelDeleteModal/NotifyChannelDeleteModal';

import TelegramChatModal from './TelegramChatModal';

const TelegramChats: React.FC = () => {
    const user = useSelector(userSelector);

    const renderRow = (item: IMessengerChat) => (
        <NotifyChannelRow
            key={item.id}
            item={item}
            title={item.chat}
            api={telegramChatAPI}
            activatedText={t`Чат активирован`}
            deactivatedText={t`Чат деактивирован`}
            renderEditModal={(modal) => (
                <NotifyChannelEditModal
                    {...modal}
                    item={item}
                    api={telegramChatAPI}
                    header={t`Редактирование чата`}
                    successText={t`Описание Telegram чата успешно обновлено`}
                />
            )}
            renderDeleteModal={(modal) => (
                <NotifyChannelDeleteModal
                    {...modal}
                    item={item}
                    api={telegramChatAPI}
                    header={t`Удаление Telegram-чата`}
                    question={t`Вы уверены, что хотите удалить Telegram-чат`}
                    name={item.chat}
                    successText={t`Чат удален`}
                />
            )}
        />
    );

    return (
        <NotifyChannelSection
            api={telegramChatAPI}
            title={t`Telegram - чаты для уведомлений`}
            limit={user?.tariff.telegram_chats_max_count_limit}
            firstColumn={{label: t`ID чата`, sort: 'id'}}
            create={{label: t`Добавить чат`, exceededType: 'telegram_chats', Modal: TelegramChatModal}}
            renderRow={renderRow}
        />
    );
};

export default TelegramChats;
